<!--uploader box-->
<div class="pc-uploader">

  <div class="upload-box">
    <div class="upload-box-content">

      <!--drop container-->
      <div [hidden]="uploading" class="drop-container" ngFileDrop [options]="options" (uploadOutput)="onUploadOutput($event)" [uploadInput]="uploadInput">
        <div class="inner">
          {{'Shared.Upload.DragText' | translate}}
          <input type="file" #uploader ngFileSelect [options]="options" (uploadOutput)="onUploadOutput($event)" [uploadInput]="uploadInput" multiple />
        </div>
      </div>

      <!--files list-->
      @if (_form.get('items')['controls'].length > 0) {
        <form [formGroup]="_form" [hidden]="uploading">
          <ul class="upload-file-list">
            @for (item of _form.get('items')['controls']; track item; let i = $index) {
              <li formArrayName="items">
                <div [formGroupName]="i">
                  <div class="row">
                    <div class="col-lg-6">
                      <mat-form-field>
                        <input matInput formControlName="fileName" placeholder="Nome documento" />
                      </mat-form-field>
                    </div>
                    <div class="col-lg-6">
                      <mat-form-field>
                        <mat-select formControlName="fileTypeId" placeholder="Tipologia">
                          @for (_fileType of _filetypes; track _fileType) {
                            <mat-option [value]="_fileType.id">{{_fileType.name}}</mat-option>
                          }
                        </mat-select>
                      </mat-form-field>
                    </div>
                  </div>
                </div>
              </li>
            }
          </ul>
          @if (_form.get('items')['controls'].length > 0) {
            <div class="text-right m-t-30">
              <button mat-ripple class="btn btn-primary btn-block" type="button" (click)="startUpload()">
                <i class="material-icons m-r-10">check</i>
                Conferma e carica documenti
              </button>
            </div>
          }
        </form>
      }

      <!--upload box-->
      <div [hidden]="!uploading" class="upload-item--box">
        @for (f of files; track f; let i = $index) {
          <div class="upload-item">
            <div class="upload-item-content">
              <div class="filename">
                <div class="filename-left">
                  <i class="ionicon ion-ios-copy"></i>
                  <span>{{ f.name }}</span>
                </div>
                <div class="filename-right">
                  <i class="ionicon ion-close-round" (click)="cancelUpload(f.id)"></i>
                </div>
              </div>
              <div class="progress-content">
                <div class="progress">
                  <span class="bar" [style.width]="f?.progress?.data?.percentage + '%'" [class.is-done]="f?.progress?.data?.percentage === 100"></span>
                </div>
              </div>
              <div class="progress-text-content">
                <span class="progress-text" [class.is-done]="f?.progress?.data?.percentage === 100">
                  <span>{{ f.progress?.data?.percentage }}% </span>
                  @if (f.progress?.data?.percentage !== 100) {
                    <span>{{'Shared.Upload.Uploading' | translate}}</span>
                  }
                  @if (f.progress?.data?.percentage === 100) {
                    <span>{{'Shared.Upload.Done' | translate}}</span>
                  }
                </span>
                @if (f.progress?.data?.percentage !== 0 && f.progress?.data?.percentage !== 100) {
                  <span class="speed-and-eta-text">
                    <span>{{ f.progress?.data?.speedHuman }} </span>
                    <span>ETA {{ f.progress?.data?.etaHuman }}</span>
                  </span>
                }
              </div>
            </div>
          </div>
        }
      </div>

    </div>
  </div>
</div>